import classnames from 'classnames';

import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {PlayPause} from '../../LinksAndButtons/PlayPause';

import './style.scss';
import {EpiImage} from "features/search/types";

interface Props {
    id?:string;
    className?: string;

    srcset?: {
        src: string;
        type: string;
    }[]
    poster?: string;
    cover?: EpiImage;

    demo?: boolean;
    playing?: boolean;
    fullWidth?: boolean;
    withSound?: boolean;
    noAutoplay?: boolean;
}

export const MovingStill: React.FunctionComponent<Props> = ({
    id, className,
    srcset, poster, cover,
    demo, playing, fullWidth, withSound, noAutoplay
}) => {
    const [autoPlaying, setAutoPlaying] = useState<boolean>(!noAutoplay);
    const videoReference = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if(videoReference.current !== null) {
            if(!playing) videoReference.current.pause();
            if(playing) {
                videoReference.current.play().catch(() => {
                    // Ignore AbortError when video is removed from DOM during navigation
                });
            }
        }
    }, [playing]);

    const startVideo = () => {
        setAutoPlaying(true);
    };

    const classes = classnames('moving-still', className, {
        'moving-still--full-width': fullWidth,
    });

    return (
        autoPlaying 
            ? <video 
                aria-hidden="true" 
                autoPlay
                className={classes}
                id={id}
                loop
                muted={!withSound}
                playsInline
                poster={poster}
                preload="metadata"
                ref={videoReference} 
                tabIndex={-1}
            >
                {srcset &&
                    srcset.map((item, i) => (
                        <source
                            src={item.src}
                            type={item.type}
                            key={"video-src-" + i}
                        />
                    ))
                }
                {demo && <source src='./assets/moving_still.mp4' type='video/mp4' key="demo-video" />}
                Your browser does not support the video tag.
            </video> 
            : <div className='moving-still__placeholder' onClick={startVideo} aria-hidden="true">
                {cover &&
                    <div className='moving-still__placeholder__cover'>
                        <img
                            src={cover.url}
                            alt={
                                cover.altText ?
                                    cover.altText :
                                    cover.description
                            }
                        />
                    </div>
                }
                <PlayPause
                    playing={false}
                />
                {/* <P center>
                    <FormattedMessage id="jm.components.ImageHeader.digitalShowing"/>
                </P> */}
            </div>
    )
};
